import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "joy-panel__header" }
const _hoisted_2 = { class: "joy-panel__subtitle" }
const _hoisted_3 = { class: "joy-panel__section" }
const _hoisted_4 = { class: "joy-panel__header" }
const _hoisted_5 = { class: "joy-panel__title" }
const _hoisted_6 = { class: "joy-panel__section" }
const _hoisted_7 = { class: "joy-panel__header" }
const _hoisted_8 = { class: "joy-panel__title" }
const _hoisted_9 = { class: "joy-panel__section" }
const _hoisted_10 = { class: "joy-panel__header" }
const _hoisted_11 = { class: "joy-panel__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "joy-panel",
    style: _normalizeStyle({top: _ctx.pos + 'px'})
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.suggest')), 1)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.title.context')), 1)
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.context.one')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.context.two')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.context.tree')), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("header", _hoisted_7, [
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.title.mission')), 1)
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.mission.one')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.mission.two')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.mission.tree')), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("header", _hoisted_10, [
        _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.title.profile')), 1)
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.profile.one')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.profile.two')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$msg('customer.brief.form.mission.description.tooltip.profile.tree')), 1)
      ])
    ])
  ], 4))
}